import { render, staticRenderFns } from "./PartRequestIndex.vue?vue&type=template&id=7accb75a"
import script from "./PartRequestIndex.vue?vue&type=script&lang=ts"
export * from "./PartRequestIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports